
















































import Vue from 'vue'
import CustomerCatalogStore from '@/store/catalog/customerCatalogs'
import SocialStreamCatalogsStore from '@/store/socialStream/socialStreamCatalogs'
import { CatalogIdentity } from '@/store/catalog/catalogApiRequest'
import { LocaleMessages } from 'vue-i18n'

interface SocialStreamCatalogs { 
  catalogs: Array<{
    value: string
    text: string
    type: string
  }>
}

export default Vue.extend({
  components: {},
  data(): SocialStreamCatalogs {
    return {
      catalogs: [],
    }
  },
  computed: {
    selectedInstagramFeed: {
        get() {
            return SocialStreamCatalogsStore.state.data.socialStreamCatalogs.instagramPostsCatalogId
        },
        set(value) {
            SocialStreamCatalogsStore.dispatch('updateInstagramPostsCatalogId', value)
        },
    },
    labelSelectInstagramFeed(): string | LocaleMessages {
      return this.$t('socialStream.catalogs.label.selectInstagramFeed')
    },
    selectedCatalog: {
        get() {
            return SocialStreamCatalogsStore.state.data.socialStreamCatalogs.productsCatalogId
        },
        set(value) {
            SocialStreamCatalogsStore.dispatch('updateProductsCatalogId', value)
        },
    },
    labelSelectCatalog(): string | LocaleMessages {
      return this.$t('socialStream.catalogs.label.selectCatalog')
    },
    getCatalogs(): Array<{ value: string, text: string }> {
      const self = this

      self.catalogs = CustomerCatalogStore.state.catalogs.map((item: CatalogIdentity) => ({
        value: item.id,
        text: item.name,
        type: item.type,
      }))
      self.catalogs = self.catalogs.filter(catalog => catalog.type !== 'wizard_test')
      return this.catalogs
    },
  },
  mounted() {
    CustomerCatalogStore.dispatch('loadCatalogList')
    SocialStreamCatalogsStore.dispatch('getSocialStreamCatalogs', this.$route.params.configId)
  },
  methods: {
    getValidationState(validation: { validated: boolean, valid: boolean | null }) {
      return validation.validated ? validation.valid : null
    },
    onSubmit() {
      const storeResult = SocialStreamCatalogsStore.dispatch('storeSocialStreamCatalogs', this.$route.params.configId)

      storeResult
        .then(success => {
          this.$router.push({ name: 'socialStreamConfigs' })
            .catch(() => {})
          return success
        })
        .catch(() => {
          console.log('something went wrong')
        })
    },
  },
})
